import { DashboardState } from '../type';
import { getBootstrapAccountTheme } from 'app/utils/account-theme';

export const dashboardState: DashboardState = {
  user: null,
  account: null,
  // Authenticated user's user preferences
  userPreferences: [],
  accountTree: [],
  // Authenticated user's account properties
  accountProperties: [],
  // Authenticated user's roles
  userRoles: [],
  products: [],

  logoURL: '',
  language: 'en',
  themeColor: getBootstrapAccountTheme(),
  sidebarMenus: [],
  isAppRequestPending: true,
  isSignOutRequestPending: false,
  supportModal: false,
  refreshRateInterval: '180', // default to 3 minutes
};
